import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import BandProfileDropdown from './partial/BandProfileDropdown.jsx';
import HamburgerMenu from './partial/HamburgerMenu.jsx';
import Logo from './Logo.jsx';
import { useT } from '../contexts/LocaleContext.jsx';
import { useUserRole } from '../hooks/useUserRole.js';
// The band chrome's buttons (.top-page-nav-button, .navigation-buttons-container,
// also on BandProfileDropdown and HamburgerMenu) are styled here. No page
// renders the listener TopPageNavigation that used to load this sheet any more
// (ENG-801); keep it ahead of TopPageNavigationBand.css so the cascade is unchanged.
import '../styles/TopPageNavigation.css';
import '../styles/TopPageNavigationBand.css';

const TopPageNavigationBand = ( {profileImageURL, showHamburgerMenu = true, onImportSonglist, pageType = 'default', onAddEvent} ) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const t = useT();
  const { bandid } = useParams();
  // Members get the band's admin pages; everyone else the public ones
  // (ENG-500). Until the role is known the header shows the public links.
  const { isMember } = useUserRole(bandid);

  if (!profileImageURL) {
    profileImageURL = sessionStorage.getItem('ProfileImageURL');
  }

  return (
    <div className="top-page-navigation-band">
      {/* Logo on the left */}
      <Logo size="small" />
      
      {/* Right-aligned navigation items */}
      <div className="navigation-buttons-container">
        <button onClick={() => navigate('/home')} className="top-page-navigation-band-button">
           {t('navigation.user')}
        </button>
        <BandProfileDropdown />
        <button data-testid="band-nav-songs" onClick={() => navigate(isMember ? `/performers/${bandid}/song-list` : `/public/bands/${bandid}/songlist`)} className={`top-page-navigation-band-button${(pageType === 'song-list' || pageType === 'add-song') ? ' top-page-nav-button--active' : ''}`}>{t('navigation.songs')}</button>
        {/* Events is member-only; fans have no public schedule yet (ENG-492). */}
        {isMember && (
          <button onClick={() => navigate(`/performers/${bandid}/events`)} className="top-page-navigation-band-button">{t('navigation.events')}</button>
        )}
        {/* The SongShake skins shop, for every viewer (ENG-864). It stays in the
            wrapped row on narrow screens; the hamburger is admin-only. */}
        <button data-testid="band-nav-shop" onClick={() => navigate('/shop')} className={`top-page-navigation-band-button${pathname === '/shop' ? ' top-page-nav-button--active' : ''}`}>{t('navigation.shop')}</button>
        {showHamburgerMenu && <HamburgerMenu profileImageURL={profileImageURL} bandSpecific={true} canManageBand={isMember} pageType={pageType} onImportSonglist={onImportSonglist} onAddEvent={onAddEvent} />}
        {/* <button onClick={() => navigate(`/performers/${bandid}/insights`)} className="top-page-navigation-band-button"><FaChartLine /> Insights</button>
        <button onClick={() => navigate(`/performers/${bandid}/media`)} className="top-page-navigation-band-button"><FaVideo /> Media</button>
        <button onClick={() => navigate(`/performers/${bandid}/store`)} className="top-page-navigation-band-button"><FaShoppingCart /> Store</button>*/}
      </div>
    </div>
  );
};

export default TopPageNavigationBand;